import { render, staticRenderFns } from "./ModuleUser.vue?vue&type=template&id=7b71b726&scoped=true&lang=pug&"
import script from "./ModuleUser.vue?vue&type=script&lang=js&"
export * from "./ModuleUser.vue?vue&type=script&lang=js&"
import style0 from "./ModuleUser.vue?vue&type=style&index=0&id=7b71b726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71b726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
